// extracted by mini-css-extract-plugin
export var copyIcon = "_rf-2";
export var discountCard = "_rf-0";
export var discountCode = "_rf-3";
export var discountContent = "_rf-1";
export var loadingCard = "_rf-4";